// Kontak customer service Fola+ untuk pengaduan/keluhan (halaman /pengaduan dan footer, syarat SIUPMSE).

/**
 * Nomor WhatsApp customer service, format internasional tanpa "+" (untuk https://wa.me/<nomor>).
 * DECISION-PENDING: nomor resmi belum tersedia; sementara nomor dummy dari PM (0809899999).
 */
export const CUSTOMER_SERVICE_WHATSAPP = '62809899999';

export const CUSTOMER_SERVICE_WHATSAPP_URL = `https://wa.me/${CUSTOMER_SERVICE_WHATSAPP}`;

/** Nomor dalam format lokal (08…) untuk ditampilkan. */
export const CUSTOMER_SERVICE_WHATSAPP_DISPLAY = `0${CUSTOMER_SERVICE_WHATSAPP.slice(2)}`;
